/* eslint-disable @typescript-eslint/no-explicit-any */

import { LeftArrowIcon, RightArrowIcon } from "staysure-component-library";

import { IconButtonWrapper } from "@/components/atoms/button-wrapper/button-wrapper";

function SlickButton({
  currentSlide,
  slideCount,
  type,
  btnDisplay,
  ...props
}: any) {
  const { onClick } = props;

  return (
    <div
      className={`absolute top-[354px] ${
        type === "next" ? "right-[8px]" : "left-[8px]"
      }`}
    >
      <IconButtonWrapper
        data-testid={`slick-button-${type}`}
        id={`slick-button-${type}`}
        btnType="icon"
        aria-label={type === "next" ? "slider-next" : "slider-prev"}
        onClick={() => {
          onClick();
        }}
        icon={type === "prev" ? <LeftArrowIcon /> : <RightArrowIcon />}
        hierarchy="secondary"
        className={` z-[1] relative bg-surface-neutral-option-1 !border-none
          min-w-[48px] w-[48px] !min-h-[48px] !h-[48px] flex justify-center shadow-[0px_0px_16px_-2px_rgba(15,23,42,0.11)]
       items-center leading-[18px] ${
         currentSlide === 0 && type === "prev" ? "hidden" : ""
       } ${
         currentSlide === slideCount - 1 && type === "next" ? "hidden" : ""
       } ${btnDisplay ? "" : "hidden"}`}
      />
    </div>
  );
}

export default SlickButton;
